import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetUsers } from "../../../store/user-store/user-actions";
import { userActions } from "../../../store/user-store/user-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";


const UsersHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("user.showAll")
    ) {
      dispatch(GetUsers(userInfo.Email));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("user.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);


  const viewDetailHanlder = (val) => {
    navigate(`/users/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/users/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      userActions.setUser({
        user: {
          email: "",
          password: "",
          repassword: "",
          name: "",
          lastName: "",
          identification: "",
          cellPhone: "",
          city: "",
          address: "",
          company: "",
          status: false,
          token: "",
          fullName: "",
          ordens: [],
          countryid: 0,
          documenttypeid: "",
          chargeid: "",
          departmentid: "",
          organizationid: "",
          surname1: "",
          surname2: "",
          profile: "",
          temporalpassword: "",
          uselimit: "",
          legaldocument: "",
          autentikarid: "",
          uanatacaid: "",
          onboardingstatus: "",
        },
      })
    );
    navigate(`/users/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };

  const getFullName = (rowData) => {
    return rowData.name + " " + rowData.surname1 + " " + rowData.surname2;
  };

  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("user.edit")) {
      buttons.push(buttonEdit);
    }
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("user.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
      body: getFullName,
    },

    {
      field: "identification",
      header: "Identificacion",
      filterMatchMode: "contains",
    },
    {
      field: "cellPhone",
      header: "teléfono",
      filterMatchMode: "contains",
    },

    {
      field: "email",
      header: "Email",
      filterMatchMode: "contains",
    },
    {
      field: "city",
      header: "Ciudad",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "137vh" }}
      >
       
        <ABADatatable
          width="20%"
          title="Personas"
          values={user.users}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Agregar",
            onClick: createHanlder,
            permission: "user.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
        />
      </div>
    </>
  );
};
export default UsersHomePage;
